"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }
  __setModuleDefault(result, mod);
  return result;
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2]) _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPrivateProfile = exports.resetEmailConfirm = exports.resetEmailRequest = exports.lineRedirect = exports.facebookRedirect = exports.googleRedirect = exports.forgotPasswordConfirm = exports.forgotPasswordRequest = exports.resetPassword = exports.registerConfirm = exports.registerRequest = exports.tempLogin = exports.autoLogin = exports.logout = exports.login = void 0;
var Config_1 = require("../Config");
var jwt_decode_1 = __importDefault(require("jwt-decode"));
var ApiUtil_1 = require("../Utils/ApiUtil");
var AsyncStorage = __importStar(require("../Utils/AsyncStorage"));
var Tracker_1 = __importDefault(require("../Utils/Tracker"));
var UserAgentUtil = __importStar(require("../Utils/UserAgentUtil"));
var query_string_1 = __importDefault(require("query-string"));
var delay = function delay(ms) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, ms);
  });
};
function login(_a, admin) {
  var username = _a.username,
    password = _a.password;
  return __awaiter(this, void 0, void 0, function () {
    var endpoint, resp, decoded, ex_1;
    return __generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          _b.trys.push([0, 4,, 6]);
          endpoint = admin ? Config_1.get().apiHost + "/user/admin/login" : Config_1.get().apiHost + "/user/login";
          if (admin && Config_1.get().management) {
            endpoint = Config_1.get().authHost + "/management/sign-in";
          }
          return [4 /*yield*/, ApiUtil_1.req(endpoint, {
            method: 'POST',
            data: {
              username: username,
              password: password
            }
          })];
        case 1:
          resp = _b.sent();
          decoded = jwt_decode_1.default(resp.token);
          if (decoded.aud !== Config_1.get().clientId) {
            throw new Error('incorrect clientId');
          }
          Config_1.get().UserOutlet.update(__assign(__assign({
            username: decoded.sub
          }, resp), decoded));
          return [4 /*yield*/, AsyncStorage.setItem((!Config_1.get().legacyUserTokenStorage && admin ? 'admin-' : '') + "token", admin && Config_1.get().management ? resp.refresh_token : resp.refresh)];
        case 2:
          _b.sent();
          return [4 /*yield*/, Config_1.get().actions.onLoginResult(null, decoded)];
        case 3:
          _b.sent();
          return [3 /*break*/, 6];
        case 4:
          ex_1 = _b.sent();
          return [4 /*yield*/, Config_1.get().actions.onLoginResult(ex_1 || new Error('unknown error'))];
        case 5:
          _b.sent();
          throw ex_1;
        case 6:
          return [2 /*return*/];
      }
    });
  });
}

exports.login = login;
function logout(admin) {
  return __awaiter(this, void 0, void 0, function () {
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4 /*yield*/, delay(600)];
        case 1:
          _a.sent();
          Config_1.get().UserOutlet.update(null);
          if (!!admin) return [3 /*break*/, 3];
          Config_1.get().CartOutlet.update({
            items: [],
            extra_items: [],
            discount_items: []
          });
          return [4 /*yield*/, AsyncStorage.removeItem('token')];
        case 2:
          _a.sent();
          return [3 /*break*/, 5];
        case 3:
          return [4 /*yield*/, AsyncStorage.removeItem(Config_1.get().legacyUserTokenStorage ? 'token' : 'admin-token')];
        case 4:
          _a.sent();
          _a.label = 5;
        case 5:
          return [2 /*return*/];
      }
    });
  });
}

exports.logout = logout;
function autoLogin(_a) {
  var _b = _a === void 0 ? {} : _a,
    refresh = _b.refresh,
    _c = _b.admin,
    admin = _c === void 0 ? false : _c;
  return __awaiter(this, void 0, void 0, function () {
    var token, _d, resp, decoded, ex_2;
    return __generator(this, function (_e) {
      switch (_e.label) {
        case 0:
          _d = refresh;
          if (_d) return [3 /*break*/, 2];
          return [4 /*yield*/, AsyncStorage.getItem(admin ? 'admin-token' : 'token')];
        case 1:
          _d = _e.sent();
          _e.label = 2;
        case 2:
          token = _d;
          if (!token) return [3 /*break*/, 10];
          _e.label = 3;
        case 3:
          _e.trys.push([3, 8,, 10]);
          return [4 /*yield*/, ApiUtil_1.req(Config_1.get().authHost + "/jwt/access?refresh_token=" + token)];
        case 4:
          resp = _e.sent();
          decoded = jwt_decode_1.default(resp.token);
          if (decoded.aud !== Config_1.get().clientId) {
            throw new Error('incorrect clientId');
          }
          Config_1.get().UserOutlet.update(__assign(__assign({
            username: decoded.sub
          }, resp), decoded));
          if (!refresh) return [3 /*break*/, 6];
          return [4 /*yield*/, AsyncStorage.setItem((admin ? 'admin-' : '') + "token", refresh)];
        case 5:
          _e.sent();
          _e.label = 6;
        case 6:
          return [4 /*yield*/, Config_1.get().actions.onLoginResult(null, decoded)];
        case 7:
          _e.sent();
          return [2 /*return*/, true];
        case 8:
          ex_2 = _e.sent();
          return [4 /*yield*/, Config_1.get().actions.onLoginResult(ex_2 || new Error('unknown error'))];
        case 9:
          _e.sent();
          throw ex_2;
        case 10:
          return [2 /*return*/, false];
      }
    });
  });
}
exports.autoLogin = autoLogin;
function tempLogin() {
  return __awaiter(this, void 0, void 0, function () {
    var token;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4 /*yield*/, AsyncStorage.getItem('tmp-token')];
        case 1:
          token = _a.sent();
          if (!!token) return [3 /*break*/, 3];
          token = 'tmp_' + Math.floor(Math.random() * 10000000000);
          return [4 /*yield*/, AsyncStorage.setItem('tmp-token', token)];
        case 2:
          _a.sent();
          _a.label = 3;
        case 3:
          Config_1.get().UserOutlet.update({
            tmp: true,
            grp: '',
            token: token,
            data: {}
          });
          return [4 /*yield*/, Config_1.get().actions.onTempLoginResult(null, null)];
        case 4:
          _a.sent();
          return [2 /*return*/];
      }
    });
  });
}

exports.tempLogin = tempLogin;
function registerRequest(username, options) {
  return __awaiter(this, void 0, void 0, function () {
    return __generator(this, function (_a) {
      if (Config_1.get().primaryUserType === 'email' || Config_1.get().primaryUserType === 'sms') {
        return [2 /*return*/, ApiUtil_1.req(Config_1.get().apiHost + "/user/register/request", {
          method: 'POST',
          data: {
            username: username,
            refer_by: (options === null || options === void 0 ? void 0 : options.refer_by) || ''
          }
        })];
      }
      if (Config_1.get().primaryUserType === 'username') {
        return [2 /*return*/, ApiUtil_1.req(Config_1.get().apiHost + "/user/register/request", {
          method: 'POST',
          data: {
            username: username,
            password: options === null || options === void 0 ? void 0 : options.password,
            refer_by: (options === null || options === void 0 ? void 0 : options.refer_by) || ''
          }
        })];
      }
      return [2 /*return*/];
    });
  });
}

exports.registerRequest = registerRequest;
function registerConfirm(_a) {
  var password = _a.password,
    access_token = _a.access_token;
  return __awaiter(this, void 0, void 0, function () {
    var resp;
    return __generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          return [4 /*yield*/, ApiUtil_1.req(Config_1.get().apiHost + "/user/register/confirm", {
            method: 'POST',
            data: {
              password: password,
              access_token: access_token
            }
          })];
        case 1:
          resp = _b.sent();
          Tracker_1.default.signUp({
            method: 'default'
          });
          return [2 /*return*/, resp];
      }
    });
  });
}
exports.registerConfirm = registerConfirm;
function forgotPasswordRequest(_a) {
  var username = _a.username;
  return __awaiter(this, void 0, void 0, function () {
    return __generator(this, function (_b) {
      return [2 /*return*/, ApiUtil_1.req(Config_1.get().apiHost + "/user/forgot-password/request", {
        method: 'POST',
        // for normal user, change the "email" according to your project's user identifier
        data: {
          username: username
        }
      }, {
        ignoreStatusCheck: true
      })];
    });
  });
}
exports.forgotPasswordRequest = forgotPasswordRequest;
function forgotPasswordConfirm(_a) {
  var new_password = _a.new_password,
    access_token = _a.access_token;
  return __awaiter(this, void 0, void 0, function () {
    return __generator(this, function (_b) {
      return [2 /*return*/, ApiUtil_1.req(Config_1.get().apiHost + "/user/forgot-password/confirm", {
        method: 'POST',
        data: {
          new_password: new_password,
          access_token: access_token
        }
      })];
    });
  });
}
exports.forgotPasswordConfirm = forgotPasswordConfirm;
function resetPassword(_a, admin) {
  var org_password = _a.org_password,
    new_password = _a.new_password;
  return __awaiter(this, void 0, void 0, function () {
    var path;
    return __generator(this, function (_b) {
      path = admin ? '/user/admin/password/reset' : '/user/password/reset';
      return [2 /*return*/, ApiUtil_1.req("" + Config_1.get().apiHost + path + "?token=" + Config_1.get().UserOutlet.getValue().token, {
        method: 'POST',
        data: {
          org_password: org_password,
          new_password: new_password
        }
      })];
    });
  });
}
exports.resetPassword = resetPassword;
function googleRedirect(refer_by) {
  if (refer_by === void 0) {
    refer_by = '';
  }
  return __awaiter(this, void 0, void 0, function () {
    var params, queryStr;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4 /*yield*/, AsyncStorage.setItem('nextRoute', "" + window.location.pathname + window.location.search)];
        case 1:
          _a.sent();
          if (typeof window !== 'undefined') {
            if (UserAgentUtil.isInLine()) {
              params = query_string_1.default.parse(window.location.search);
              params.openExternalBrowser = '1';
              queryStr = query_string_1.default.stringify(params);
              window.location.href = window.location.pathname + '?' + queryStr;
            } else {
              window.location.href = Config_1.get().apiHost + "/google/redirect?refer_by=" + refer_by;
            }
          }
          return [2 /*return*/];
      }
    });
  });
}

exports.googleRedirect = googleRedirect;
function facebookRedirect(refer_by) {
  if (refer_by === void 0) {
    refer_by = '';
  }
  return __awaiter(this, void 0, void 0, function () {
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4 /*yield*/, AsyncStorage.setItem('nextRoute', "" + window.location.pathname + window.location.search)];
        case 1:
          _a.sent();
          if (typeof window !== 'undefined') {
            window.location.href = Config_1.get().apiHost + "/facebook/redirect?refer_by=" + refer_by;
          }
          return [2 /*return*/];
      }
    });
  });
}

exports.facebookRedirect = facebookRedirect;
function lineRedirect(refer_by) {
  if (refer_by === void 0) {
    refer_by = '';
  }
  return __awaiter(this, void 0, void 0, function () {
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4 /*yield*/, AsyncStorage.setItem('nextRoute', "" + window.location.pathname + window.location.search)];
        case 1:
          _a.sent();
          if (typeof window !== 'undefined') {
            window.location.href = Config_1.get().apiHost + "/line/redirect?refer_by=" + refer_by;
          }
          return [2 /*return*/];
      }
    });
  });
}

exports.lineRedirect = lineRedirect;
var resetEmailRequest = function resetEmailRequest(_a) {
  var email = _a.email;
  return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          return [4 /*yield*/, ApiUtil_1.req(Config_1.get().apiHost + "/user/reset-email/request?token=" + Config_1.get().UserOutlet.getValue().token, {
            method: 'POST',
            data: {
              email: email
            }
          })];
        case 1:
          _b.sent();
          return [2 /*return*/];
      }
    });
  });
};

exports.resetEmailRequest = resetEmailRequest;
var resetEmailConfirm = function resetEmailConfirm(_a) {
  var emailToken = _a.emailToken;
  return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          return [4 /*yield*/, ApiUtil_1.req(Config_1.get().apiHost + "/user/reset-email/confirm", {
            method: 'POST',
            data: {
              email_token: emailToken,
              access_token: Config_1.get().UserOutlet.getValue().token
            }
          })];
        case 1:
          _b.sent();
          return [2 /*return*/];
      }
    });
  });
};

exports.resetEmailConfirm = resetEmailConfirm;
var getPrivateProfile = function getPrivateProfile() {
  return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4 /*yield*/, ApiUtil_1.req(Config_1.get().apiHost + "/user/private/profile?token=" + Config_1.get().UserOutlet.getValue().token, {
            method: 'GET'
          })];
        case 1:
          return [2 /*return*/, _a.sent()];
      }
    });
  });
};
exports.getPrivateProfile = getPrivateProfile;